import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { ContentService } from 'src/app/service/content.service';

@Component({
  selector: 'app-lsr-privacy',
  templateUrl: './lsr_privacy.component.html',
  styleUrls: ['./lsr_privacy.component.css']
})
export class LsrPrivacyComponent {
   privacyHtml = '';
   redirectUrl = '';
   webRoot = '';
  constructor(private contentService: ContentService,
              private router: Router,
              private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.webRoot = AppConfig.appsettings.navigatorRoot;
    this.redirectUrl = this.normalizeRedirectUrl(AppConfig.appsettings.redirectUrl); 
    this.contentService.getPrivacyHtml().subscribe({
      next: (html) => (this.privacyHtml = html),
      error: () => (this.privacyHtml = '<p>Unable to load privacy content.</p>')
    });
  }
  

    redirectLandingPage(event: Event): void {
      event.preventDefault();
      window.location.href = this.redirectUrl;
    }

    private normalizeRedirectUrl(url: string): string {
    const source = (url && url.trim().length > 0) ? url.trim() : this.webRoot;
    if (!source) {
      return '/';
    }
    let normalized = source.replace(/\/admin\/?$/i, '/');
    if (!normalized.endsWith('/')) {
      normalized += '/';
    }
    return normalized;
  }
 
  handleLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a') as HTMLAnchorElement | null;
    if (!anchor) return;

    const href = (anchor.getAttribute('href') || '').trim();
    if (!href) return;

    // Allow non-router links
    const isExternalProtocol =
      /^(mailto:|tel:|https?:|ftp:)/i.test(href);

    if (isExternalProtocol) {
      // Let browser handle mailto/tel/http
      return;
    }

    // Handle internal Angular routes only
    event.preventDefault();
    this.router.navigateByUrl(href);
  }
}
